import { render, staticRenderFns } from "./operationCollege.vue?vue&type=template&id=2c829074&scoped=true&"
import script from "./operationCollege.vue?vue&type=script&lang=js&"
export * from "./operationCollege.vue?vue&type=script&lang=js&"
import style0 from "./operationCollege.vue?vue&type=style&index=0&id=2c829074&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c829074",
  null
  
)

export default component.exports